import { getSetup } from '../../did-utility/src/Functions/getSetup';
import SSPContentFieldAccessor from 'sspcontentext/src/model/accessor/SSPContentFieldAccessor';

const setup = getSetup();
let order: string[] = ['power', 'consumption', 'range'];
if (setup.market.name === 'FRA') {
	order = ['power', 'consumption', 'critAir'];
}
if (setup.market.name === 'MEX') {
	order = ['power', 'consumptionMex', 'range'];
}

export default order;

export const tileConfig = {
	default: [
		{
			id: 'powerElectric',
			class: 'power',
			condition: (engine: SSPContentFieldAccessor) =>
				engine.str('engine_type') === 'Electric' &&
				!(engine.str('max_output_kw') && engine.str('max_output_ps')),
			getProps: (engine: SSPContentFieldAccessor, i18next: any) => ({
				headline: 'OverviewBoxPower',
				value1: engine.str('fuel_power2', '-'),
				unit1: i18next.t('FuelPowerUnit'),
				value2: engine.str('fuel_power2_PS', '-'),
				unit2: i18next.t('FuelPowerPSUnit'),
			}),
		},
		{
			id: 'powerNotElectric',
			class: 'power',
			condition: (engine: SSPContentFieldAccessor) =>
				engine.str('engine_type') !== 'Electric' &&
				!(engine.str('max_output_kw') && engine.str('max_output_ps')),
			getProps: (engine: SSPContentFieldAccessor, i18next: any) => ({
				headline: 'OverviewBoxPower',
				value1: engine.str('fuel_power', '-'),
				unit1: i18next.t('FuelPowerUnit'),
				value2: engine.str('fuel_power_PS', '-'),
				unit2: i18next.t('FuelPowerPSUnit'),
			}),
		},
		{
			id: 'powerSystem',
			class: 'power',
			condition: (engine: SSPContentFieldAccessor) =>
				engine.str('max_output_kw') && engine.str('max_output_ps'),
			getProps: (engine: SSPContentFieldAccessor, i18next: any) => ({
				headline: 'OverviewBoxSystemPower',
				value1: engine.str('max_output_kw', '-'),
				unit1: i18next.t('FuelPowerUnit'),
				value2: engine.str('max_output_ps'),
				unit2: i18next.t('FuelPowerPSUnit'),
			}),
		},
		{
			id: 'battery',
			condition: (engine: SSPContentFieldAccessor) =>
				engine.str('engine_type') === 'Electric' &&
				engine.has('battery_size'),
			getProps: (engine: SSPContentFieldAccessor, i18next: any) => ({
				headline: 'OverviewBoxBattery',
				value1: engine.str('battery_size', '-'),
				unit1: i18next.t('BatteryUnit'),
			}),
		},
		{
			id: 'chargingDC',
			condition: (engine: SSPContentFieldAccessor) =>
				engine.str('engine_type') === 'Electric' &&
				engine.has('battery_charging_dc_100'),
			getProps: (engine: SSPContentFieldAccessor, i18next: any) => ({
				headline: 'OverviewBoxChargingTime',
				value1: engine.str('battery_charging_dc_100', '-'),
				unit1: i18next.t('ChargingTimeUnit'),
			}),
		},
		{
			id: 'chargingDCMax',
			condition: (engine: SSPContentFieldAccessor) =>
				engine.str('engine_type') === 'Electric' &&
				engine.has('battery_charging_dc_max_power'),
			getProps: (engine: SSPContentFieldAccessor, i18next: any) => ({
				headline: 'OverviewBoxChargingMaxPower',
				value1: engine.str('battery_charging_dc_max_power', '-'),
				unit1: i18next.t('ChargingMaxPowerUnit'),
			}),
		},
		{
			id: 'chargingAC',
			condition: (engine: SSPContentFieldAccessor) =>
				engine.str('engine_type') === 'Electric' &&
				engine.has('battery_charging_ac_100'),
			getProps: (engine: SSPContentFieldAccessor, i18next: any) => ({
				headline: 'OverviewBoxChargingTime',
				value1: engine.str('battery_charging_ac_100', '-'),
				unit1: i18next.t('ChargingTimeUnit'),
			}),
		},
		{
			id: 'chargingBidirectional',
			condition: (engine: SSPContentFieldAccessor) =>
				engine.str('engine_type') === 'Electric' &&
				engine.has('battery_charging_bidirectional'),
			getProps: (engine: SSPContentFieldAccessor, i18next: any) => ({
				headline: 'OverviewBoxChargingBidirectional',
				value1: engine.str('battery_charging_bidirectional', '-'),
				unit1: i18next.t('ChargingBidirectionalUnit'),
			}),
		},
		{
			id: 'chargingDCRange',
			condition: (engine: SSPContentFieldAccessor) =>
				engine.str('engine_type') === 'Electric' &&
				engine.has('battery_charging_range_dc'),
			getProps: (engine: SSPContentFieldAccessor, i18next: any) => ({
				headline: 'OverviewBoxChargingDCRange',
				value1: engine.str('battery_charging_range_dc', '-'),
				unit1: i18next.t('ChargingDCRangeUnit'),
			}),
		},
		{
			id: 'batteryNominalVoltage',
			condition: (engine: SSPContentFieldAccessor) =>
				engine.str('engine_type') === 'Electric' &&
				engine.has('battery_nominal_voltage'),
			getProps: (engine: SSPContentFieldAccessor, i18next: any) => ({
				headline: 'OverviewBoxBatteryNominalVoltage',
				value1: engine.str('battery_nominal_voltage', '-'),
				unit1: i18next.t('BatteryNominalVoltageUnit'),
			}),
		},
		{
			id: 'batteryType',
			condition: (engine: SSPContentFieldAccessor) =>
				engine.str('engine_type') === 'Electric' &&
				engine.has('battery_type'),
			getProps: (engine: SSPContentFieldAccessor, i18next: any) => ({
				headline: 'OverviewBoxBatteryType',
				value1: engine.str('battery_type', '-')
			}),
		},
		{
			id: 'acceleration',
			condition: (engine: SSPContentFieldAccessor) =>
				engine.has('acceleration'),
			getProps: (engine: SSPContentFieldAccessor, i18next: any) => ({
				headline: 'OverviewBoxAcceleration',
				value1: engine.float('acceleration', NaN),
				unit1: i18next.t('AccelerationUnit'),
			}),
		},
		{
			id: 'topSpeed',
			condition: (engine: SSPContentFieldAccessor) =>
				engine.has('top_speed'),
			getProps: (engine: SSPContentFieldAccessor, i18next: any) => ({
				headline: 'OverviewBoxTopSpeed',
				value1: engine
					.float('top_speed', NaN)
					.toLocaleString(i18next.language),
				unit1: i18next.t('SpeedUnit'),
			}),
		},
		{
			id: 'motorDrive',
			condition: (engine: SSPContentFieldAccessor) =>
				engine.has('motor_drive'),
			getProps: (engine: SSPContentFieldAccessor) => ({
				headline: 'OverviewBoxMotorDrive',
				value1: engine.str('motor_drive', '-'),
			}),
		},
		{
			id: 'motorGear',
			condition: (engine: SSPContentFieldAccessor) =>
				engine.has('motor_gear'),
			getProps: (engine: SSPContentFieldAccessor) => ({
				headline: 'OverviewBoxMotorGear',
				value1: engine.str('motor_gear', '-'),
			}),
		},
		{
			id: 'fuelTypeElectric',
			condition: (engine: SSPContentFieldAccessor) =>
				engine.str('engine_type') === 'Electric',
			getProps: (engine: SSPContentFieldAccessor) => ({
				headline: 'OverviewBoxFuelType',
				value1: engine.str('fuel2', '-'),
			}),
		},
		{
			id: 'fuelTypeNotElectric',
			condition: (engine: SSPContentFieldAccessor) =>
				engine.str('engine_type') !== 'Electric',
			getProps: (engine: SSPContentFieldAccessor, i18next: any) => ({
				headline: 'OverviewBoxFuelType',
				value1: i18next.t(engine.str('engine_type')),
			}),
		},
		{
			id: 'modelYear',
			condition: (engine: SSPContentFieldAccessor) =>
				engine.str('engine_type') !== 'Electric',
			getProps: (contentModel: SSPContentFieldAccessor) => ({
				headline: 'ModelYear',
				value1: contentModel.float('modelyear'),
			}),
		},
		{
			id: 'range',
			condition: (engine: SSPContentFieldAccessor) =>
				engine.str('engine_type') === 'Electric' ||
				engine.str('engine_type') === 'HybridPetrol',
			getProps: (engine: SSPContentFieldAccessor, i18next: any) => ({
				headline: 'OverviewBoxRangeCombined',
				value1: 'wltp_range_combined',
				unit1: i18next.t('LengthUnit'),
				type: 'wltp',
			}),
		},

		{
			id: 'consumption',
			condition: (engine: SSPContentFieldAccessor) =>
				engine.has('engine_type'),
			getProps: () => ({
				headline: 'OverviewBoxConsumption',
				value1: 'wltp_consumption_sustaining_combined',
				unit1: 'FuelConsumptionUnit',
				value2: 'wltp_consumption_electrical_combined',
				unit2: 'ElectricConsumptionUnit',
				add: 'moreData',
				type: 'consumption',
				disclaimer: 1,
			}),
		},

		//country specific tiles

		//AUS
		{
			id: 'powerNotElectricAUS',
			class: 'power',
			condition: (
				engine: SSPContentFieldAccessor,
				_: any,
				setup: {
					market: {
						name: string;
					};
				}
			) =>
				setup.market.name === 'AUS' &&
				engine.str('max_output_kw') &&
				engine.str('max_torque'),
			getProps: (engine: SSPContentFieldAccessor, i18next: any) => ({
				headline: 'OverviewBoxPower',
				value1: engine.str('max_output_kw', '-'),
				unit1: i18next.t('FuelPowerUnit'),
				value2: engine.str('max_torque', '-'),
				unit2: i18next.t('TorqueUnit'),
			}),
		},

		//FRA
		{
			id: 'critAir',
			condition: (
				engine: SSPContentFieldAccessor,
				_: any,
				setup: {
					market: {
						name: string;
					};
				}
			) => engine.has('engine_type') && setup.market.name === 'FRA',
			getProps: (engine: SSPContentFieldAccessor) => ({
				headline: 'CritAir',
				svg:
					engine.str('engine_type') === 'Electric'
						? 'bev'
						: engine.str('engine_type') === 'HybridPetrol' ||
						  engine.str('engine_type') === 'Petrol' ||
						  engine.str('engine_type') === 'Gas'
						? 1
						: 2,
			}),
		},

		// MEX
		{
			id: 'consumptionMex',
			condition: (
				engine: SSPContentFieldAccessor,
				_: any,
				setup: {
					market: {
						name: string;
					};
				}
			) => setup.market.name === 'MEX',
			getProps: (engine: SSPContentFieldAccessor, i18next: any) => ({
				headline: 'OverviewBoxConsumption',
				value1: 'ObservedCombinedCO2Emissions',
				unit1: i18next.t('WltpMexicoEmissionUnit'),
				add: 'moreData',
				type: 'consumption',
				disclaimer: 1,
			}),
		},
	],
};

export const usedCarTileConfig = {
	default: [
		{
			id: 'InitialRegistration',
			getProps: (
				engine: SSPContentFieldAccessor,
				i18next: any,
				contentModel: SSPContentFieldAccessor
			) => ({
				headline: 'InitialRegistration',
				value1: new Date(
					contentModel.obj('initialreg').Timestamp
				).toLocaleDateString(i18next.language, {
					year: 'numeric',
					month: '2-digit',
					day: '2-digit',
				}),
			}),
		},
		{
			id: 'MileageUsedCar',
			getProps: (
				engine: SSPContentFieldAccessor,
				i18next: any,
				contentModel: SSPContentFieldAccessor
			) => ({
				headline: 'MileageUsedCar',
				value1: contentModel
					.float('mileage', NaN)
					.toLocaleString(i18next.language, {
						useGrouping: true,
					}),
				unit1: i18next.t('LengthUnit'),
			}),
		},
		{
			id: 'NextGeneralInspection',
			getProps: (
				engine: SSPContentFieldAccessor,
				i18next: any,
				contentModel: SSPContentFieldAccessor
			) => ({
				headline: 'NextGeneralInspection',
				value1:
					new Date(
						contentModel.str('generalinspection', '-')
					).toLocaleDateString(i18next.language, {
						year: 'numeric',
						month: '2-digit',
						day: '2-digit',
					}) === 'Invalid Date'
						? contentModel.str('generalinspection', '-')
						: new Date(
								contentModel.str('generalinspection', '-')
						  ).toLocaleDateString(i18next.language, {
								year: 'numeric',
								month: '2-digit',
								day: '2-digit',
						  }),
			}),
		},
		{
			id: 'WarrantyType',
			getProps: (
				engine: SSPContentFieldAccessor,
				i18next: any,
				contentModel: SSPContentFieldAccessor
			) => ({
				headline: 'WarrantyType',
				value1: contentModel.bool('warranty')
					? i18next.t('WarrantyTrue')
					: '-',
			}),
		},
		{
			id: 'PreviousOwners',
			getProps: (
				engine: SSPContentFieldAccessor,
				i18next: any,
				contentModel: SSPContentFieldAccessor
			) => ({
				headline: 'PreviousOwners',
				value1: contentModel.str('pown', '-'),
			}),
		},
		{
			id: 'ModelYear',
			getProps: (
				engine: SSPContentFieldAccessor,
				i18next: any,
				contentModel: SSPContentFieldAccessor
			) => ({
				headline: 'ModelYear',
				value1: contentModel.float('modelyear'),
			}),
		},
	],
};
